/** ----------------- Banner ----------------- */
type BannerProps = {
    image: string;
    alt?: string;
    className?: string;
};

export default function Banner({ image, alt = "Banner", className = "" }: BannerProps) {
    return (
        <div className={`relative w-full ${className}`}>
            <img
                src={image}
                alt={alt}
                className="w-full h-auto object-cover"
            />
        </div>
    );
}
